import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-square-button-vehicle',
  templateUrl: './square-button-vehicle.component.html',
  styleUrls: ['./square-button-vehicle.component.scss'],
})
export class SquareButtonVehicleComponent {
  @Input() titleButton = '';
  @Input() isActive = false;
  @Input() isDisabled = false;
  @Output() buttonClick = new EventEmitter<void>();

  handleClick(event: Event): void {
    event.stopPropagation();
    this.buttonClick.emit();
    // cambiar de color a activo
  }
}
